module.exports = __webpack_public_path__ + "static/media/baseMeme16.a88c0bc6.jpg";